import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

const sections = [
  {
    t: "Disclaimer",
    text: "Aan de inhoud van deze website kunnen geen rechten worden ontleend. Wij besteden zorg aan juistheid en actualiteit, maar aanvaarden geen aansprakelijkheid voor fouten, onvolledigheden of gevolgen die uit gebruik van de informatie voortvloeien.",
  },
  {
    t: "Berekeningen en scenario's",
    text: "Alle berekeningen, ramingen, prognoses of scenario's op deze website (waaronder de ROI-calculator, voorbeeldcasus en indicatie-tools) zijn indicatief. Uitkomsten zijn afhankelijk van de juistheid en volledigheid van ingevoerde gegevens. Ze vormen geen garantie voor werkelijke resultaten in een pilot of programma.",
  },
  {
    t: "Verwijzingen en bronnen",
    text: "Wetenschappelijke bronnen en cijfers worden zo zorgvuldig mogelijk geciteerd. Bronnen (bijvoorbeeld CBS StatLine) worden gebruikt voor context, de exacte cijfers per gemeente of periode zijn direct opvraagbaar bij de bronhouder.",
  },
  {
    t: "Intellectueel eigendom",
    text: "Het LevelLeven-programma, het LevelLeven Transitiemodel en de methodiek zijn eigendom van LevelLeven, een concept van OutsideTen. Overname zonder toestemming is niet toegestaan.",
  },
  {
    t: "Wijzigingen",
    text: "LevelLeven behoudt zich het recht voor deze disclaimer te wijzigen. De meest recente versie staat op deze pagina.",
  },
];

export default function Disclaimer() {
  usePageMeta({ title: "Disclaimer, LevelLeven", description: "Disclaimer bij het gebruik van deze website en tools." });
  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Disclaimer</SectionLabel>
          <h1 className="font-heading text-5xl sm:text-6xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
            Zorgvuldig gebruik van{" "}
            <span className="italic text-[#E06B3F]">wat wij delen</span>.
          </h1>
        </div>
      </section>
      <section className="pb-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16 space-y-10">
          {sections.map((s) => (
            <div key={s.t}>
              <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">{s.t}</h2>
              <p className="text-[#4A5D4E] leading-relaxed font-light text-lg">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
